import {
    TEAMDASHBOARDSCREEN_LOAD,
    TEAMDASHBOARDSCREEN_SET
} from '../../../actionDefinitions';
import {
    fetchJibeProgressOverTimeBreakdownStats,
    fetchJibeSessionsOverTimeStats
} from '../../../api/v3/CalibrationV3Api';
import {
    fetchCalibratedOnSurveyQuestions,
    fetchUserTeamsStats,
    fetchDomainValues
} from '../../../api/v3/DataApi';
import {
    fetchUsersStats
} from '../../../api/v3/SurveyActivityV3Api';
import {
    fetchAgentReportAccumulated,

    fetchAlerts,
    _makeAlertSeen
} from '../../../api/v3/SystemDashboardV3Api';

import {
    fetchTicketCountOverTimeBreakdownStats,
    fetchResponseOverTimeBreakdownStats,
} from '../../../api/v3/TeamDashboardApi';
export function loadSystemDashboardBasicData() {
    return dispatch => {
        dispatch(loadUserTeamsStats());
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadDomainValues());
    };
}

export function loadTeamDashboardOverallScreen(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    return dispatch => {
        dispatch(loadTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId));
        dispatch(loadJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId));
        dispatch(loadResponseOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId));
    };
}

export function loadTeamDashboardBreakdownScreen(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters, initSelectedAggregationIdsInLegend, supervisorDomainId) {
    return dispatch => {
        dispatch(loadTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters,
            initSelectedAggregationIdsInLegend, supervisorDomainId));
        dispatch(loadJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId));
        dispatch(loadResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId));

    };
}

//Ticket count
export function loadTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchTicketCountOverTimeBreakdownStats('Supervisor', fromDate, toDate, timePeriodicity, teamId, filtersAndTeamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { ticketCountOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters,
    initSelectedAggregationIdsInLegend, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, filtersAndTeamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { ticketCountOverTimeByBreakdownStats: payload.result } }))
            .then(props => initSelectedAggregationIdsInLegend(props.payload.ticketCountOverTimeByBreakdownStats))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Jibe score
export function loadJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchJibeProgressOverTimeBreakdownStats('Supervisor', fromDate, toDate, timePeriodicity, filtersAndTeamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { jibeProgressOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, filtersAndTeamId, teamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { jibeProgressBreakdownOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Jibe Session
export function loadJibeSessionsOverTimeStats(fromDate, toDate, timePeriodicity, teamId) {
    return dispatch =>
        fetchJibeSessionsOverTimeStats(fromDate, toDate, timePeriodicity, teamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { jibeSessionsOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Response
export function loadResponseOverTimeStats(fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchResponseOverTimeBreakdownStats('Supervisor', fromDate, toDate, timePeriodicity, teamId, filtersAndTeamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { responseOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters, supervisorDomainId) {
    let filtersAndTeamId = selectedFilters.slice();
    filtersAndTeamId.push({ id: teamId, domainId: supervisorDomainId });
    return dispatch =>
        fetchResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, filtersAndTeamId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { responseBreakdownOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function downloadTeamDashboardReport(fromDate, toDate, timePeriodicity) {
    return dispatch =>
        fetchAgentReportAccumulated(fromDate, toDate, timePeriodicity)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { isDownloadingReport: false } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload: { isDownloadingReport: false } }))
}

export function loadAlerts() {
    return dispatch =>
        fetchAlerts()
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { alerts: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadUserTeamsStats() {
    return dispatch =>
        fetchUserTeamsStats()
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { userTeamsStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadUsersStats() {
    return dispatch =>
        fetchUsersStats()
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { usersStats: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function makeAlertSeen(alertId) {
    return dispatch =>
        _makeAlertSeen(alertId)
            .then(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, payload: {} }))
            .catch(payload => dispatch({ type: TEAMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: TEAMDASHBOARDSCREEN_SET, updatedProps });
    }
}
